import React from 'react';
import { ReactComponent as LoadingRingsIcon } from '../../../icons/loading-rings.svg';
import './thread-view-loading.scss';

const ThreadViewLoading: React.FC = () => {
  return (
    <div className='thread-view-loading-container'>
      <div className='message-loading-container'>
        <div className='message-loading'></div>
        <div className='message-loading'></div>
      </div>
      <div className='input-loading'>
        <div className='input-placeholder'>Loading ...</div>
        <div className='actions-row-placeholder'>
          <div className='upload-button-placeholder'></div>
          <div className='spinner'>
            <LoadingRingsIcon />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThreadViewLoading;
